var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { ChildProperty, Property } from '@syncfusion/ej2-base';
/**
 * Configures the edit behavior of the TreeGrid, defining how records can be added, modified, or deleted.
 */
export class EditSettings extends ChildProperty {
}
__decorate([
    Property(false)
], EditSettings.prototype, "allowAdding", void 0);
__decorate([
    Property(false)
], EditSettings.prototype, "allowEditing", void 0);
__decorate([
    Property(false)
], EditSettings.prototype, "allowDeleting", void 0);
__decorate([
    Property('Cell')
], EditSettings.prototype, "mode", void 0);
__decorate([
    Property('Top')
], EditSettings.prototype, "newRowPosition", void 0);
__decorate([
    Property(true)
], EditSettings.prototype, "allowEditOnDblClick", void 0);
__decorate([
    Property(true)
], EditSettings.prototype, "showConfirmDialog", void 0);
__decorate([
    Property(false)
], EditSettings.prototype, "showDeleteConfirmDialog", void 0);
__decorate([
    Property('')
], EditSettings.prototype, "template", void 0);
__decorate([
    Property({})
], EditSettings.prototype, "dialog", void 0);
__decorate([
    Property(false)
], EditSettings.prototype, "allowNextRowEdit", void 0);
